import { useAutoAnimate } from "@formkit/auto-animate/react"

interface InputProps {
	props?: any
	className?: string | null
	label?: string | null
	errMsg?: string
	hasError?: boolean
}

const ElemSelect: React.FC<InputProps> = ({ className, props, label, errMsg, hasError, children }) => {
	const [animationRef] = useAutoAnimate<HTMLDivElement>()
	return (
		<label className={"relative block " + (className || "")}>
			<select
				className={
					"pr-[50px] pt-4 w-full peer rounded-[9px] px-4 text-lg font-Manrope text-black h-[72px] leading-[58px] placeholder-transparent outline-0 bg-white appearance-none bg-right bg-no-repeat bg-[url('/src/bgimages/icon-dropdown.png')] " +
					(hasError ? "  js-formerror " : "")
				}
				{...props}
			>
				{children}
			</select>
			<span
				className={
					(!!props.value ? "-translate-y-4" : "") +
					" -translate-y-4 transition absolute left-0 top-0 font-Museo text-lg px-4 h-[72px] leading-[72px]" +
					(hasError ? "  text-red " : " text-brown ")
				}
			>
				{label}
			</span>
			<div ref={animationRef}>{hasError && <div className="formErrorMsg ">{errMsg}</div>}</div>
		</label>
	)
}

export default ElemSelect
